import ctl from '@netlify/classnames-template-literals'
import { forwardRef, ReactNode } from 'react'
import { ScaleProps } from '../../utilities'

type InputProps = {
	className: string
}

export type InputAssemblyProps = {
	children: (p: { inputProps: InputProps }) => ReactNode
	hasError?: boolean
	isDisabled?: boolean
	highlight?: boolean
} & ScaleProps

export const InputAssembly = forwardRef<HTMLDivElement, InputAssemblyProps>(
	function InputAssembly(
		{ children, hasError = false, highlight = false, isDisabled = true, scale = 'medium' }: InputAssemblyProps,
		ref,
	) {
		const errorClassName = 'ring-2 ring-red-500 '
		const highlightClassName = 'ring-2 ring-purple-400 '
		const inertClassName = 'ring-1 ring-grey-300 focus-within:ring-2 focus-within:ring-purple-400'
		const disabledClassName = 'bg-grey-100 text-grey-400 opacity-20'

		const wrapperClassName = ctl(`
			flex justify-stretch items-center
			w-full rounded-md border-0 
			text-grey-800 shadow-sm  bg-white
			text-left
			${hasError && errorClassName}
			${highlight && highlightClassName}
			${(!hasError && !highlight) && inertClassName}
			${isDisabled && disabledClassName}
			sm:text-sm sm:leading-6
			[&>*:first-child]:pl-3
			[&>*:last-child]:pr-3
		`)

		const inputProps = {
			className: ctl(`
			relative
			bg-transparent
			${scale === 'small' && 'text-sm'}
			${scale === 'medium' && 'text-base'}
			${scale === 'large' && 'text-lg'}
			py-2.5 
			overflow-x-auto
			flex-grow
			min-w-0
			text-left
			border-0
			placeholder:text-grey-400 
			focus:outline-0 focus:ring-0
		`),
		} satisfies InputProps

		return (
			<div className={wrapperClassName} ref={ref}>
				{children({ inputProps })}
			</div>
		)
	},
)
